export default "__VITE_ASSET__bMizFxaS__"